/*
  assets/mad-cart-count.js: the header cart icon counts the doors on the estimate too.

  Release B (Seth 2026-10-12): "Add to estimate" puts a door on the browser estimate (shown on /cart under "Your
  estimate", nothing charged), and "the header cart icon's number includes estimate doors". The icon's markup is
  snippets/mad-cart-icon.liquid (the header and every section repaint of it): a marker with the cart's count and the
  theme's words for it, both drawings of the icon, and the theme's bubble. This adds the estimate doors not sent yet
  (MadEstimateList.meta().sentAt empty: a sent estimate stops counting, it is with Magnolia):
    number   cart items + unsent estimate doors (shown up to 99, as the theme does)
    icon     the full drawing when either has something
    words    "2 items" (the theme's own), "2 doors on your estimate", "1 item, 2 doors on your estimate"
  It runs again after every repaint of the icon (a MutationObserver on the link's own children; its own writes are
  dropped from the observer's queue, so it never loops), on mad:estimate:changed (an add, an edit, a send, another
  tab), on pageshow (Back to a kept page) and when the theme editor reloads the header. Display only: estimate doors
  never enter the Shopify cart, and Liquid's count stays the cart's.
  window.MadCartCount = { render, setCart, summary, unsent }
*/
(function () {
  'use strict';
  if (window.MadCartCount) return;
  var doc = document, observer = null, watched = null;

  function anchor() { return doc.getElementById('cart-icon-bubble'); }
  /* the doors on the estimate that were not sent yet; 0 when the list is off, not loaded or sent */
  function unsent(list) {
    var L = list === undefined ? window.MadEstimateList : list;
    if (!L || !L.enabled) return 0;
    try { var m = L.meta && L.meta(); return m && m.sentAt ? 0 : Math.max(0, Number(L.count()) || 0); } catch (e) { return 0; }
  }
  /* what the icon shows for n cart items and m estimate doors; cartText is the theme's words for n alone */
  function summary(n, m, cartText) {
    n = Math.max(0, Number(n) || 0); m = Math.max(0, Number(m) || 0);
    var items = n + (n === 1 ? ' item' : ' items'), doors = m + (m === 1 ? ' door' : ' doors') + ' on your estimate';
    var words = n && m ? items + ', ' + doors : m ? doors : n ? (cartText || items) : '';
    return { total: n + m, full: n + m > 0, number: n + m < 100 ? String(n + m) : '', words: words };
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function render() {
    var a = anchor();
    if (!a) return;
    watch(a);
    var mark = a.querySelector('[data-mad-cart-count]');
    if (!mark) return; /* an icon this script does not know: left as the theme drew it */
    var s = summary(mark.getAttribute('data-mad-cart-count'), unsent(), mark.getAttribute('data-mad-cart-text'));
    var empty = a.querySelector('[data-mad-cart-icon="empty"]'), full = a.querySelector('[data-mad-cart-icon="full"]');
    if (empty && full && empty.classList.contains('hidden') !== s.full) {
      empty.classList.toggle('hidden', s.full);
      full.classList.toggle('hidden', !s.full);
    }
    var bubble = a.querySelector('.cart-count-bubble');
    if (s.full) {
      var html = (s.number ? '<span aria-hidden="true">' + s.number + '</span>' : '') + '<span class="visually-hidden">' + esc(s.words) + '</span>';
      if (!bubble) { bubble = doc.createElement('div'); bubble.className = 'cart-count-bubble'; a.appendChild(bubble); }
      if (bubble.innerHTML !== html) bubble.innerHTML = html;
    } else if (bubble && bubble.parentNode) bubble.parentNode.removeChild(bubble);
    if (observer && observer.takeRecords) observer.takeRecords(); /* its own writes are not a repaint */
  }
  /* after a cart change the wizard knows the new count before any repaint (assets/mad-wizard-cart.js updateCartIcon) */
  function setCart(n) {
    var a = anchor(), mark = a && a.querySelector('[data-mad-cart-count]');
    if (mark) {
      n = Math.max(0, Number(n) || 0);
      mark.setAttribute('data-mad-cart-count', String(n));
      mark.setAttribute('data-mad-cart-text', n + (n === 1 ? ' item' : ' items'));
    }
    render();
  }
  /* a repaint replaces the link's children: render again (the link itself stays; the theme editor may replace it) */
  function watch(a) {
    if (watched === a || typeof window.MutationObserver !== 'function') return;
    if (observer) observer.disconnect();
    observer = new window.MutationObserver(function () { render(); });
    observer.observe(a, { childList: true });
    watched = a;
  }

  doc.addEventListener('mad:estimate:changed', render);
  window.addEventListener('pageshow', render);
  doc.addEventListener('shopify:section:load', render);
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', render); else render();

  window.MadCartCount = { render: render, setCart: setCart, summary: summary, unsent: unsent };
})();
